<template>
  <div class="center-profile-container">
    <div class="user-info-content">
      <div class="username">{{profile.username}}</div>
      <div class="profile-item">
        <span></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CenterProfile",
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
<style lang="scss" scoped>
.center-profile-container {
  padding-left: 13mm;
  padding-right: 13mm;
  width: 100%;
  box-sizing: border-box;
  .user-info-content {
    width: 70%;
    min-height: 96px;
    margin: 0 auto;
    text-align: center;
    box-sizing: border-box;
    .username {
      font-weight: 700;
      font-size: 20px;
      line-height: 20px;
      margin-bottom: 10px;
    }
  }
}
</style>
